import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { mdiCheckCircleOutline, mdiClose, mdiDotsHorizontal } from '@mdi/js'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getDateFormatted } from '@/services/date'
import { useImage } from '@/shared/composables/image'
import { eventApi } from '@/enitites/event'
import { EventPreview } from '@/enitites/event/model/types'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationEventChip',
  props: {
    canEdit: { type: Boolean },
    event: null
  },
  emits: ["reloadEvents"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'reloadEvents'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  canEdit?: boolean
  event: EventPreview
};

const { getEventImg } = useImage()
const router = useRouter()





const loading = ref(false)
const eventDate = computed(() => getDateFormatted(props.event.dateStart))

function handleClickEvent() {
  router.push({
    name: 'Event',
    params: { id: `${props.event.id}` },
  })
}

async function publishEvent() {
  loading.value = true
  const resp = await eventApi.publishEvent(props.event.id)
  if (resp) {
    props.event.status = 'published'
  }
  loading.value = false
}

async function deleteEvent() {
  const resp = await eventApi.deleteEvent(props.event.id)
  if (resp) {
    emit('reloadEvents')
  }
}

return { __sfc: true,getEventImg, router, props, emit, loading, eventDate, handleClickEvent, publishEvent, deleteEvent, mdiCheckCircleOutline, mdiClose, mdiDotsHorizontal }
}

})